export enum TipoServicoCte {
  NORMAL = 0,
  SUBCONTRATACAO = 1,
  REDESPACHO = 2,
  REDESPACHO_INTERMEDIARIO = 3,
}